// extracted by mini-css-extract-plugin
export default {"colorResult":"style_colorResult__LNJmS"};